<template>
  <SectionContainer>
    <AppHead />
    <FormContainer
      class="form-container--preamble mb-5"
      title="En préambule"
      level="preamble"
      :hide-button="true"
    >
      <div class="my-3">
        <p :class="paragraphStyle">
          Cette section vous invite, en tant qu’instance territoriale, à évaluer
          la manière dont sont gérées les eaux pluviales sur votre territoire.
          Le processus d’évaluation proposé est une version automatisée de
          <a
            :href="selfDiagnosePdfLink"
            target="_blank"
            class="text-secondary text-500"
          >
            l’Autodiagnostic municipal de gestion durable des eaux pluviales
          </a>
          (2ème édition).
        </p>
        <p :class="paragraphStyle">
          À l’issue de votre auto-évaluation, vous pourrez télécharger le
          rapport en format PDF. Les points à améliorer auront été identifiés et
          des pistes d’amélioration concrètes, issues du
          <a
            :href="guidePdfLink"
            target="_blank"
            class="text-secondary text-500"
            >Guide d'accompagnement</a
          >, vous seront précisément proposées.
        </p>
        <p :class="paragraphStyle">
          Pour chacune des questions de l’autodiagnostic, il vous est demandé de
          vous évaluer sur une échelle de 1 à 10. La note de 10 correspond à une
          réponse entièrement positive, alors que la note de 1 correspond à une
          réponse entièrement négative.
        </p>
        <p :class="paragraphStyle">
          Le bouton « N.A. » signifie que la question ne s’applique pas au
          contexte spécifique de votre territoire ou que vous ignorez la
          réponse. Cette question ne sera pas prise en compte dans l’évaluation.
        </p>
        <div :class="paragraphStyle">
          Les seuils d’évaluation sont définis ainsi :
          <ul>
            <li class="py-1">Insatisfaisant = inférieur ou égal à 4</li>
            <li class="py-1">Intermédiaire = entre 4 et 7</li>
            <li class="py-1">Satisfaisant = supérieur ou égal à 7</li>
          </ul>
        </div>
        <p :class="paragraphStyle">
          L’interprétation de la variabilité du pointage à l’intérieur des
          seuils vous revient entièrement.
        </p>
        <p :class="paragraphStyle">
          Pour certaines questions, des indicateurs vous sont suggérés. Ceux-ci
          peuvent être utilisés pour vous guider dans votre évaluation.
        </p>
      </div>
      <template slot="buttons">
        <div
          ref="buttons"
          class="custom-buttons d-flex w-100 justify-content-evenly"
        >
          <button
            class="btn btn-primary"
            type="button"
            @click="showStartNewUserSurveySelector()"
          >
            Commencer un nouveau questionnaire
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="showRetrieveExistingUserSurvey()"
          >
            Retrouver un questionnaire
          </button>
        </div>
      </template>
    </FormContainer>

    <RetrieveExistingUserSurvey
      id="retrieveExistingUserSurvey"
      :show="isSelected('retrieveExistingUserSurvey')"
    />
    <StartNewUserSurveySelector
      id="startNewUserSurveySelector"
      :show="isSelected('startNewUserSurveySelector')"
    />
  </SectionContainer>
</template>

<script>
import RetrieveExistingUserSurvey from '../Components/RetrieveExistingUserSurvey.vue'
import StartNewUserSurveySelector from '../Components/StartNewUserSurveySelector.vue'
import FormContainer from '../Components/SurveyForm/FormContainer.vue'

import App from '../Layouts/App'
export default {
  components: {
    RetrieveExistingUserSurvey,
    FormContainer,
    StartNewUserSurveySelector,
  },
  layout: App,
  data() {
    return {
      selfDiagnosePdfLink: this.$page.props.selfDiagnosePdfLink,
      guidePdfLink: this.$page.props.guidePdfLink,
      retrieveExistingUserSurvey: false,
      selectedUserSurveyFlow: '',
      paragraphStyle: 'fs-5 text-400',
    }
  },
  computed: {
    isUserConnected() {
      return this.$page.props.auth.user && !this.$page.props.is_guest
    },
  },
  methods: {
    isSelected(elementId) {
      return this.selectedUserSurveyFlow === elementId
    },
    showRetrieveExistingUserSurvey() {
      this.showSectionAndScroll('retrieveExistingUserSurvey')
    },
    showStartNewUserSurveySelector() {
      if (this.isUserConnected) {
        this.$inertia.visit(this.$route('survey.start'))
      } else {
        this.showSectionAndScroll('startNewUserSurveySelector')
      }
    },
    async showSectionAndScroll(elementId) {
      if (this.isSelected(elementId)) {
        await this.resetSelection()
        return
      }
      // Avoid scrolling issues on Chrome And Safari
      window.scrollTo({
        top: document.querySelector('main').offsetTop,
        left: 0,
        behavior: 'smooth',
      })

      this.selectedUserSurveyFlow = elementId
      const headerHeight =
        document.querySelector('header').firstChild.clientHeight
      const yOffset = -headerHeight
      await this.$nextTick()
      const element = this.$refs.buttons
      const y = element.getBoundingClientRect().top + yOffset

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      })
    },
    async resetSelection() {
      this.selectedUserSurveyFlow = ''
      await this.$nextTick()

      window.scrollTo({
        top: document.querySelector('main').offsetTop,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@use '@/bootstrap' as *;

.form-container--preamble {
  p {
    strong {
      font-weight: 600;
    }
  }
}

.custom-buttons {
  .btn {
    padding: 1rem 2rem;
    font-size: 1rem;
    line-height: 0.8em;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.11rem;
  }
  @include media-breakpoint-down(lg) {
    flex-direction: column;
    .btn {
      margin: 1em auto;
    }
  }
  @include media-breakpoint-up(lg) {
    .btn {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
}
</style>
